/**
 * Central registration file for all custom elements
 * Defines and registers all custom web components used throughout the application
 */

import { VisibilityElement } from './visibility'
import { ModalElement } from './modal'
import { InViewElement } from './in-view'
import { ReadMore } from './read-more'
import { StickyHeader } from './sticky-header'
import { MiniCart } from './mini-cart'
import { ProductForm } from './product-form'
import { VariantSelector } from './variant-selector'
import { EnhancedProductForm } from './enhanced-product-form'
import { QuantityInput } from './quantity-input'
import { Carousel } from './carousel'
import { StickyProductForm } from './sticky-product-form'
import 'snippets/notice-global/notice-global'
import { CustomForm } from '@/components/custom-elements/custom-form'
import { LightBoxElement } from '@/components/custom-elements/lightbox'
import 'snippets/navigation/localization-form'
import register from 'preact-custom-element'
import { ListDisplayElement } from '@/components/custom-elements/list-display'
import { ButtonElement } from './button'
import { CountdownElement } from './countdown'
import { GiftCardForm } from './gift-card-form'
import { BulkProductForm } from './bulk-product-form'
import { KlaviyoStarRatingElement } from './klaviyo-star-rating'
import { B2BPrice } from './b2b-price'
import { MarqueeElement } from './marquee'
import { TabbedContent } from './tabbed-content'
import { UniversalSizeSelector } from './universal-size-selector'
import { FreeShippingUSP } from './free-shipping-usp'
import { ConditionalCartContentElement } from './conditional-cart-content'
import { FilterToggleButtonElement, SortToggleButtonElement } from './searchspring-buttons'
import { ImageViewToggleButtonElement } from './image-view-toggle-button'
import { RecentSearchesStoreElement } from './recent-searches-store'
import { StorageModalElement } from './storage-modal'
import { VerticalCarouselElement } from './vertical-carousel'
import { CartShareButtonElement } from './cart-share-button'
import { CartPrintButtonElement } from './cart-print-button'
import { CartLineVariantSelectorElement } from './cart-line-variant-selector'
import {
  LoyaltyCartBannerElement,
  LoyaltyHeaderBadgeElement,
  LoyaltyTierSpendDataElement,
  LoyaltyRewardsSpendDataElement,
  LoyaltyRewardsGridElement
} from './loyalty-elements'
import { GwpCartBlockElement } from './gwp-cart-block'

register(MiniCart, 'mini-cart', ['acceleratedCheckout'])
customElements.define('x-visibility', VisibilityElement)
customElements.define('x-lightbox', LightBoxElement)
customElements.define('x-modal', ModalElement)
customElements.define('x-in-view', InViewElement)
customElements.define('x-quantity-input', QuantityInput)
customElements.define('sticky-header', StickyHeader)
customElements.define('read-more', ReadMore)
customElements.define('product-form', ProductForm)
customElements.define('variant-selector', VariantSelector)
customElements.define('x-list-display', ListDisplayElement)
customElements.define('x-custom-form', CustomForm)
customElements.define('enhanced-product-form', EnhancedProductForm)
customElements.define('x-carousel', Carousel)
customElements.define('sticky-product-form', StickyProductForm)
customElements.define('x-button', ButtonElement)
customElements.define('x-countdown', CountdownElement)
customElements.define('gift-card-form', GiftCardForm)
customElements.define('bulk-product-form', BulkProductForm)
customElements.define('klaviyo-star-rating', KlaviyoStarRatingElement)
customElements.define('b2b-price', B2BPrice)
customElements.define('x-marquee', MarqueeElement)
customElements.define('x-tabbed-content', TabbedContent)
customElements.define('universal-size-selector', UniversalSizeSelector)
customElements.define('free-shipping-usp', FreeShippingUSP)
customElements.define('conditional-cart-content', ConditionalCartContentElement)
customElements.define('x-ss-filter-toggle', FilterToggleButtonElement)
customElements.define('x-ss-sort-toggle', SortToggleButtonElement)
customElements.define('x-ss-image-view-toggle', ImageViewToggleButtonElement)
customElements.define('x-recent-searches-store', RecentSearchesStoreElement)
customElements.define('x-storage-modal', StorageModalElement)
customElements.define('x-vertical-carousel', VerticalCarouselElement)
customElements.define('cart-share-button', CartShareButtonElement)
customElements.define('cart-print-button', CartPrintButtonElement)
customElements.define('cart-line-variant-selector', CartLineVariantSelectorElement)
customElements.define('loyalty-cart-banner', LoyaltyCartBannerElement)
customElements.define('loyalty-header-badge', LoyaltyHeaderBadgeElement)
customElements.define('loyalty-tier-spend-data', LoyaltyTierSpendDataElement)
customElements.define('loyalty-rewards-spend-data', LoyaltyRewardsSpendDataElement)
customElements.define('loyalty-rewards-grid', LoyaltyRewardsGridElement)
customElements.define('gwp-cart-block', GwpCartBlockElement)
